import React from 'react';
import { Play } from 'lucide-react';
import styles from './Component/CSS/EpisodePlayScreen.module.css';
import { useAudioPlayer } from '../components/audio/AudioPlayerContext';
import { useSubscriptionCheck } from '../hooks/useSubscriptionCheck';

const EpisodeCard = ({ audioData }) => {
  // Use the global audio player context
  const { currentAudio, playAudio, isPlaying } = useAudioPlayer();
  const { checkSubscriptionBeforePlay } = useSubscriptionCheck();
  
  // For debugging - remove this in production
  console.log('Audio Data:', audioData);
  
  // Handle case when data is not yet loaded
  if (!audioData) {
    return <div className={styles.loading}>Loading episode information...</div>;
  }
  
  const handleListenNow = () => {
    // Check subscription before playing
    if (!checkSubscriptionBeforePlay()) {
      return;
    }
    // Format episode data for the audio player
    const audioPlayerData = {
      id: audioData.id,
      title: audioData.title,
      author: audioData.created_by, // You might want to fetch actual author name if available
      song_url: audioData.audio_url,
      image: audioData.computer_image_url || audioData.mobile_image_url,
      duration: audioData.duration,
      audioId:audioData.id
    };
    
    // Play the audio using the global context
    playAudio(audioPlayerData);
  };
  
  // Check if this episode is currently playing
  const isEpisodePlaying = () => {
    return currentAudio && currentAudio.id === audioData.id;
  };
  
  // Format duration from seconds to minutes:seconds
  const formatDuration = (seconds) => {
    if (!seconds) return '0:00';
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.imageSection}>
          <img
            src={audioData.computer_image_url || audioData.mobile_image_url}
            alt="Episode Cover"
            className={styles.coverImage}
          />
        </div>
        
        <div className={styles.contentSection}>
          <h1 className={styles.title}>{audioData.title}</h1>
          
          <div className={styles.metadataSection}>
            <div className={styles.metadataItem}>
              <span className={styles.metadataLabel}>Duration:</span>
              <span className={styles.metadataValue}>{formatDuration(audioData.duration)}</span>
            </div>
            <div className={styles.metadataItem}>
              <span className={styles.metadataLabel}>Genre:</span>
              <span className={styles.metadataValue}>{audioData.genre_name}</span>
            </div>
            <div className={styles.metadataItem}>
              <span className={styles.metadataLabel}>Language:</span>
              <span className={styles.metadataValue}>{audioData.language}</span>
            </div>
            <div className={styles.metadataItem}>
              <span className={styles.metadataLabel}>Views:</span>
              <span className={styles.metadataValue}>{audioData.views_count}</span>
            </div>
          </div>
          
          <p className={styles.description}>{audioData.description}</p>
          
          <button 
            className={`${styles.listenNowButton} ${isEpisodePlaying() ? styles.playing : ''}`}
            onClick={handleListenNow}
          >
            <Play size={24} />
            {isEpisodePlaying() && isPlaying ? 'Now Playing' : 'Listen Now'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EpisodeCard;